<template>
  <div id="app">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive && isRouterAlive" />
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive && isRouterAlive" />
    <!-- <firstLogin></firstLogin> -->
    <!-- <router-view v-if="isRouterAlive&&!$route.meta.keepAlive" /> -->
  </div>
</template>

<script>
// import firstLogin from '@/components/first-login';
export default {
  name: 'App',
  components: {
    // firstLogin
    // [NavBar.name]: NavBar,
    // [Icon.name]: Icon,
    // [Cell.name]: Cell,
    // [CellGroup.name]: CellGroup
  },
  provide() {
    return {
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  mounted() {},
  updated() {},

  methods: {
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    }
  }
};
</script>
<style>
</style>
